import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react';
import cn from 'classnames';
import { getTestIds } from '../../utils/TestIds';
import styles from './GradientIcon.module.scss';
export const GetGradientIconTID = (parentTestId)=>getTestIds(parentTestId);
export const GRADIENT_ICON_ANIMATED_CLASS = styles.animated;
export const GradientIcon = (param)=>{
    let { icon, size = 18, animated = false, animateOnParentHover = false, className, testId } = param;
    const { GradientIconTID } = useMemo(()=>GetGradientIconTID(testId), [
        testId
    ]);
    const iconRef = useRef(null);
    const [maskUrl, setMaskUrl] = useState(null);
    useLayoutEffect(()=>{
        var _iconRef_current;
        const svg = (_iconRef_current = iconRef.current) === null || _iconRef_current === void 0 ? void 0 : _iconRef_current.querySelector('svg');
        if (!svg) return;
        const clone = svg.cloneNode(true);
        clone.querySelectorAll('[stroke="currentColor"]').forEach((el)=>{
            el.setAttribute('stroke', 'black');
        });
        clone.querySelectorAll('[fill="currentColor"]').forEach((el)=>{
            el.setAttribute('fill', 'black');
        });
        const encoded = encodeURIComponent(new XMLSerializer().serializeToString(clone));
        setMaskUrl('url("data:image/svg+xml,'.concat(encoded, '")'));
    }, []);
    return /*#__PURE__*/ _jsxs("span", {
        className: cn(styles.gradientIcon, animated && styles.animated, animateOnParentHover && styles.animateOnParentHover, className),
        style: {
            width: size,
            height: size
        },
        "data-testid": GradientIconTID.Root(),
        "data-gradient-icon": "",
        children: [
            /*#__PURE__*/ _jsx("span", {
                ref: iconRef,
                children: icon
            }),
            maskUrl && /*#__PURE__*/ _jsx("span", {
                className: styles.gradientOverlay,
                "data-gradient-overlay": "",
                style: {
                    WebkitMaskImage: maskUrl,
                    maskImage: maskUrl
                }
            })
        ]
    });
};
